import React from 'react';
import withDashboardSidebar from '../../components/with-dashboard-sidebar';

import { Container, Title } from './styles';

const NLPTraining = () => (
  <Container>
    <Title>
      NLPTraining
    </Title>
  </Container>
);

NLPTraining.propTypes = {};

export default withDashboardSidebar(NLPTraining);
